import { useEffect, useState } from "react";
import { API_GRAPHQL } from "../../constants";

export function useGetProductsBySupplier(id) {

    const url = `${API_GRAPHQL}`;
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [products, setProducts] = useState([]);

    useEffect(() => {

        async function getProductsBySup(url, id) {
            try{
                setIsLoading(true);
                setIsError(false);

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {'Content-Type' : 'application/json'},
                    body: JSON.stringify({
                        query: `{
                            supplier(id:${id}) {
                                data{
                                    attributes{
                                        products(pagination: {limit: 100}){
                                            data{
                                                id
                                                attributes{
                                                    name
                                                    category{
                                                        data{
                                                            attributes{
                                                                place
                                                            }
                                                        }
                                                    }
                                                    varenummer
                                                    supplier{
                                                        data{
                                                            id
                                                            attributes{
                                                                name
                                                            }
                                                        }
                                                    }
                                                    price
                                                    description
                                                    technical_info{
                                                        armHeight
                                                        power
                                                        fullWidth
                                                        fullHeight
                                                        vekt
                                                        power
                                                        packaging
                                                        engine
                                                    }
                                                    produktKatalog{
                                                        data{
                                                            attributes{
                                                                url
                                                            }
                                                        }
                                                    }
                                                    image{
                                                        data{
                                                            attributes{
                                                                url
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }`
                    })
                });

                const json = await response.json();
                setProducts(json.data.supplier.data.attributes.products.data);
            } catch(error){
                console.log(error);
                setIsError(true);
            }finally{
                setIsLoading(false);
            }
        }

        getProductsBySup(url, id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);

    return {products, isLoading, isError};
}

export default useGetProductsBySupplier;